module.exports = "https://cdn.redage.net/src/views/player/hudevo/phonenew/components/map/map.jpg";